interface SectionHeadProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  accent?: boolean;
}

export default function SectionHead({
  kicker,
  title,
  desc,
  align = "center",
  accent = false,
}: SectionHeadProps) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={"flex max-w-2xl flex-col " + alignCls}>
      <span
        className={
          "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[12px] font-semibold tracking-wide " +
          (accent ? "bg-gold-100 text-gold-700" : "bg-brand-50 text-brand-700")
        }
      >
        <i className={"ri-flashlight-fill " + (accent ? "text-gold-600" : "text-brand-500")} />
        {kicker}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-[#241b13] md:text-[32px]">
        {title}
      </h2>
      {desc && (
        <p className={"mt-3 text-[14px] leading-relaxed text-stone-500 md:text-[15px] " + (align === "center" ? "" : "")}>
          {desc}
        </p>
      )}
    </div>
  );
}